// // import React, { useState, useEffect, useRef } from 'react';
// // import { 
// //     Modal,
// //     Box,
// //     Typography,
// //     Button,
// //     IconButton,
// //     Snackbar,
// //     Alert
// // } from '@mui/material';
// // import CloseIcon from '@mui/icons-material/Close';
// // import axios from 'axios';

// // import { localAxiosToken} from '../Axios/axios'

// // // Helper function to convert VAPID key
// // const urlBase64ToUint8Array = (base64String) => {
// //     const padding = '='.repeat((4 - base64String.length % 4) % 4);
// //     const base64 = (base64String + padding)
// //         .replace(/-/g, '+')
// //         .replace(/_/g, '/');
// //     const rawData = window.atob(base64);
// //     return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
// // };

// // // Helper function to compare array buffers
// // const arrayBufferEqual = (buf1, buf2) => {
// //     if (buf1.byteLength !== buf2.byteLength) return false;
// //     const dv1 = new Uint8Array(buf1);
// //     const dv2 = new Uint8Array(buf2);
// //     for (let i = 0; i < buf1.byteLength; i++) {
// //         if (dv1[i] !== dv2[i]) return false;
// //     }
// //     return true;
// // };

// // const PushNotificationManager = ({ userId, isSubscribed: propIsSubscribed }) => {
// //     const [showPrompt, setShowPrompt] = useState(false);
// //     const [notificationPermission, setNotificationPermission] = useState('default');
// //     const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });
// //     const initialized = useRef(false);
    
// //     // Get isSubscribed from props or localStorage
// //     const getIsSubscribed = () => {
// //         if (propIsSubscribed !== undefined) {
// //             return propIsSubscribed;
// //         }
// //         const storedValue = localStorage.getItem('isSubscribed');
// //         return storedValue === 'true'; // Convert string to boolean
// //     };
    
// //     const [currentIsSubscribed, setCurrentIsSubscribed] = useState(getIsSubscribed());

// //     console.log('[Debug] Component props - userId:', userId, 'propIsSubscribed:', propIsSubscribed);
// //     console.log('[Debug] Final isSubscribed value:', currentIsSubscribed);

// //     useEffect(() => {
// //         console.log('[Component] PushNotificationManager mounted/updated (Page reload scenario included)');
// //         console.log('[Debug] userId:', userId, 'currentIsSubscribed:', currentIsSubscribed);
        
// //         if (!userId) {
// //             console.log('[Debug] No userId provided, skipping initialization');
// //             return;
// //         }

// //         // Always check for latest isSubscribed value from localStorage (handles page reload)
// //         const latestIsSubscribed = getIsSubscribed();
// //         if (currentIsSubscribed !== latestIsSubscribed) {
// //             console.log('[Debug] isSubscribed value changed, reinitializing...');
// //             initialized.current = false;
// //             setCurrentIsSubscribed(latestIsSubscribed);
// //             return; // Return early, let the next effect run handle the new value
// //         }

// //         if (initialized.current) {
// //             console.log('[Debug] Component already initialized for current state, skipping');
// //             return;
// //         }

// //         console.log('[Debug] Initializing component (fresh mount or page reload)');
// //         initialized.current = true;

// //         if (!('Notification' in window) || !('serviceWorker' in navigator) || !('PushManager' in window)) {
// //             console.error('[Error] Push notifications are not supported in this browser.');
// //             return;
// //         }

// //         // Check current permission state
// //         const permission = Notification.permission;
// //         console.log('[Debug] Current notification permission:', permission);
// //         setNotificationPermission(permission);

// //         // Determine if we should show the modal and/or make API call
// //         // Show modal in these cases:
// //         // 1. Browser permission is 'default' (need browser permission first)
// //         // 2. User is not subscribed (need user consent even if browser permission exists)
// //         const shouldShowModal = permission === 'default' || !currentIsSubscribed;
        
// //         // Only make direct API call if:
// //         // - User is not subscribed AND permission is granted AND we've already shown modal once
// //         // This prevents auto-API calls on component mount
// //         const shouldMakeApiCall = false; // We'll only call API through user interaction

// //         console.log('[Debug] shouldShowModal:', shouldShowModal, 'shouldMakeApiCall:', shouldMakeApiCall);
// //         console.log('[Debug] permission:', permission, 'currentIsSubscribed:', currentIsSubscribed);

// //         if (shouldShowModal) {
// //             if (permission === 'default') {
// //                 console.log('[Prompt] Showing permission prompt to user (browser permission needed)');
// //             } else {
// //                 console.log('[Prompt] Showing permission prompt to user (user consent needed)');
// //             }
// //             setShowPrompt(true);
// //         } else if (currentIsSubscribed && permission === 'granted') {
// //             console.log('[Info] User already subscribed and permission granted, no action needed');
// //         } else if (permission === 'denied') {
// //             console.log('[Info] Notifications denied by user, no action needed');
// //         }
// //     }, [userId, currentIsSubscribed]);

// //     // Separate effect to handle page reload scenarios
// //     useEffect(() => {
// //         console.log('[Page Reload Handler] Checking for page reload scenario');
        
// //         // On every mount, ensure we have the latest isSubscribed value from localStorage
// //         const storedIsSubscribed = getIsSubscribed();
// //         if (storedIsSubscribed !== currentIsSubscribed) {
// //             console.log('[Page Reload] Updating isSubscribed from localStorage:', storedIsSubscribed);
// //             setCurrentIsSubscribed(storedIsSubscribed);
// //         }
// //     }, []); // Empty dependency array - runs once on mount (page reload)

// //     const handlePushSubscription = async () => {
// //         // Only proceed if user is not subscribed
// //         if (currentIsSubscribed) {
// //             console.log('[Debug] User already subscribed, skipping API call');
// //             return;
// //         }

// //         setSnackbar({ open: true, message: 'Subscribing to notifications...', severity: 'info' });
        
// //         try {
// //             // Check for VAPID key before proceeding
// //             const vapidKey = process.env.REACT_APP_VAPID_PUBLIC_KEY;
// //             if (!vapidKey) {
// //                 throw new Error('VAPID public key is missing from environment variables.');
// //             }
// //             console.log('[Debug] VAPID Key found. Proceeding...');

// //             // Get service worker registration
// //             const registration = await navigator.serviceWorker.ready;
// //             console.log('[Debug] Service Worker is ready.');

// //             // Get existing subscription
// //             let subscription = await registration.pushManager.getSubscription();
            
// //             // Unsubscribe if VAPID key has changed
// //             if (subscription) {
// //                 const currentKey = subscription.options.applicationServerKey;
// //                 const newKey = urlBase64ToUint8Array(vapidKey);
                
// //                 if (!currentKey || !arrayBufferEqual(currentKey, newKey)) {
// //                     console.log('[Info] VAPID key has changed. Unsubscribing old subscription...');
// //                     await subscription.unsubscribe();
// //                     subscription = null;
// //                 }
// //             }

// //             // Create a new subscription if one does not exist
// //             if (!subscription) {
// //                 console.log('[Debug] No existing subscription found. Creating a new one...');
// //                 subscription = await registration.pushManager.subscribe({
// //                     userVisibleOnly: true,
// //                     applicationServerKey: urlBase64ToUint8Array(vapidKey),
// //                 });
// //                 console.log('[Success] New subscription created:', subscription.endpoint);
// //             } else {
// //                 console.log('[Success] Reusing existing subscription:', subscription.endpoint);
// //             }

// //             // Prepare payload for API call
// //             const payload = {
// //                 user_id: userId,
// //                 subscription: {
// //                     endpoint: subscription.endpoint,
// //                     keys: {
// //                         auth: subscription.toJSON().keys.auth,
// //                         p256dh: subscription.toJSON().keys.p256dh,
// //                     },
// //                 },
// //             };

// //             const accessToken = localStorage.getItem('accessToken');
// //             console.log('[Debug] accessToken from localStorage:', accessToken ? 'Exists' : 'Does not exist');

// //             if (!accessToken) {
// //                 throw new Error('User is not authenticated. Cannot save push subscription.');
// //             }

// //             // Log the axios config before the call
// //             const axiosConfig = localAxiosToken('/notifications/savePushSubscription', payload, accessToken);
// //             console.log('[Debug] Axios config for API call:', JSON.stringify(axiosConfig, null, 2));

// //             // Make the API call
// //             const response = await axios(axiosConfig);
            
// //             console.log('[Success] API call to save subscription succeeded:', response.data);
            
// //             // Update local state and localStorage to reflect successful subscription
// //             setCurrentIsSubscribed(true);
// //             localStorage.setItem('isSubscribed', 'true');
            
// //             setSnackbar({
// //                 open: true,
// //                 message: 'Successfully subscribed to notifications!',
// //                 severity: 'success',
// //             });
// //             setShowPrompt(false);
// //         } catch (error) {
// //             console.error('[Error] Subscription process failed:', error);
// //             setSnackbar({
// //                 open: true,
// //                 message: `Failed to subscribe: ${error.message || 'Unknown error'}`,
// //                 severity: 'error',
// //             });
// //         }
// //     };

// //     const requestNotificationPermission = async () => {
// //         try {
// //             let permission = notificationPermission;
            
// //             // Only request permission if it's 'default'
// //             if (permission === 'default') {
// //                 permission = await Notification.requestPermission();
// //                 setNotificationPermission(permission);
// //             }
            
// //             if (permission === 'granted') {
// //                 console.log('[Info] Notification permission available.');
                
// //                 // Only make API call if user is not subscribed
// //                 if (!currentIsSubscribed) {
// //                     console.log('[Info] User not subscribed, starting subscription process...');
// //                     await handlePushSubscription();
// //                 } else {
// //                     console.log('[Info] User already subscribed, just closing modal');
// //                     setSnackbar({
// //                         open: true,
// //                         message: 'Notifications enabled! You are already subscribed.',
// //                         severity: 'success',
// //                     });
// //                 }
// //                 setShowPrompt(false);
// //             } else if (permission === 'denied') {
// //                 console.warn('[Warning] Notification permission denied by user.');
// //                 setSnackbar({
// //                     open: true,
// //                     message: 'Permission denied. You can enable it in your browser settings.',
// //                     severity: 'warning',
// //                 });
// //                 setShowPrompt(false);
// //             }
// //         } catch (error) {
// //             console.error('[Error] Error requesting permission:', error);
// //             setSnackbar({ open: true, message: `Failed to request permission: ${error.message}`, severity: 'error' });
// //         }
// //     };

// //     const handleClose = () => setShowPrompt(false);
// //     const handleSnackbarClose = () => setSnackbar(prev => ({ ...prev, open: false }));

// //     // Show modal in these cases:
// //     // 1. Browser permission is 'default' (need browser permission)
// //     // 2. User is not subscribed (need user consent)
// //     const shouldShowModal = (notificationPermission === 'default' || !currentIsSubscribed) && showPrompt;

// //     return (
// //         <>
// //             <Modal
// //                 open={shouldShowModal}
// //                 onClose={handleClose}
// //                 aria-labelledby="notification-permission-modal"
// //                 aria-describedby="notification-permission-description"
// //             >
// //                 <Box
// //                     sx={{
// //                         position: 'absolute',
// //                         top: '50%',
// //                         left: '50%',
// //                         transform: 'translate(-50%, -50%)',
// //                         width: { xs: '90%', sm: '80%', md: '500px' },
// //                         bgcolor: 'background.paper',
// //                         boxShadow: 24,
// //                         p: 4,
// //                         borderRadius: 2,
// //                         outline: 'none'
// //                     }}
// //                 >
// //                     <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
// //                         <Typography variant="h6" component="h1" fontWeight='600'>
// //                             Enable Notifications
// //                         </Typography>
// //                         <IconButton onClick={handleClose}>
// //                             <CloseIcon />
// //                         </IconButton>
// //                     </Box>
                    
// //                     <Typography variant="body1" sx={{ mb: 3 }}>
// //                         {notificationPermission === 'default' 
// //                             ? "Would you like to receive notifications from our application? This will allow us to keep you updated with important information."
// //                             : "Enable push notifications to stay updated with important information and updates from our application."
// //                         }
// //                     </Typography>
                    
// //                     <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
// //                         <Button 
// //                             variant="outlined" 
// //                             onClick={handleClose}
// //                         >
// //                             Not Now
// //                         </Button>
// //                         <Button 
// //                             variant="contained" 
// //                             onClick={requestNotificationPermission}
// //                         >
// //                             Allow
// //                         </Button>
// //                     </Box>
// //                 </Box>
// //             </Modal>

// //             <Snackbar
// //                 open={snackbar.open}
// //                 autoHideDuration={6000}
// //                 onClose={handleSnackbarClose}
// //                 anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
// //             >
// //                 <Alert 
// //                     onClose={handleSnackbarClose} 
// //                     severity={snackbar.severity}
// //                     sx={{ width: '100%' }}
// //                 >
// //                     {snackbar.message}
// //                 </Alert>
// //             </Snackbar>
// //         </>
// //     );
// // };

// // export default PushNotificationManager;
// import React, { useState, useEffect, useRef } from 'react';
// import { 
//     Modal,
//     Box,
//     Typography,
//     Button,
//     IconButton,
//     Snackbar,
//     Alert
// } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import axios from 'axios';

// import { localAxiosToken} from '../Axios/axios'

// // Helper function to convert VAPID key
// const urlBase64ToUint8Array = (base64String) => {
//     const padding = '='.repeat((4 - base64String.length % 4) % 4);
//     const base64 = (base64String + padding)
//         .replace(/-/g, '+')
//         .replace(/_/g, '/');
//     const rawData = window.atob(base64);
//     return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
// };

// // Helper function to compare array buffers
// const arrayBufferEqual = (buf1, buf2) => {
//     if (buf1.byteLength !== buf2.byteLength) return false;
//     const dv1 = new Uint8Array(buf1);
//     const dv2 = new Uint8Array(buf2);
//     for (let i = 0; i < buf1.byteLength; i++) {
//         if (dv1[i] !== dv2[i]) return false;
//     }
//     return true;
// };

// const PushNotificationManager = ({ userId, isSubscribed: propIsSubscribed }) => {
//     const [showPrompt, setShowPrompt] = useState(false);
//     const [notificationPermission, setNotificationPermission] = useState('default');
//     const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });
//     const initialized = useRef(false);
    
//     // Get isSubscribed from props or localStorage
//     const getIsSubscribed = () => {
//         if (propIsSubscribed !== undefined) {
//             return propIsSubscribed;
//         }
//         const storedValue = localStorage.getItem('isSubscribed');
//         return storedValue === 'true'; // Convert string to boolean
//     };
    
//     const [currentIsSubscribed, setCurrentIsSubscribed] = useState(getIsSubscribed());

//     console.log('[Debug] Component props - userId:', userId, 'propIsSubscribed:', propIsSubscribed);
//     console.log('[Debug] Final isSubscribed value:', currentIsSubscribed);

//     useEffect(() => {
//         console.log('[Component] PushNotificationManager mounted/updated (Page reload scenario included)');
//         console.log('[Debug] userId:', userId, 'currentIsSubscribed:', currentIsSubscribed);
        
//         if (!userId) {
//             console.log('[Debug] No userId provided, skipping initialization');
//             return;
//         }

//         // Always check for latest isSubscribed value from localStorage (handles page reload)
//         const latestIsSubscribed = getIsSubscribed();
//         if (currentIsSubscribed !== latestIsSubscribed) {
//             console.log('[Debug] isSubscribed value changed, reinitializing...');
//             initialized.current = false;
//             setCurrentIsSubscribed(latestIsSubscribed);
//             return; // Return early, let the next effect run handle the new value
//         }

//         if (initialized.current) {
//             console.log('[Debug] Component already initialized for current state, skipping');
//             return;
//         }

//         console.log('[Debug] Initializing component (fresh mount or page reload)');
//         initialized.current = true;

//         if (!('Notification' in window) || !('serviceWorker' in navigator) || !('PushManager' in window)) {
//             console.error('[Error] Push notifications are not supported in this browser.');
//             return;
//         }

//         // Check current permission state
//         const permission = Notification.permission;
//         // console.log('[Debug] Current notification permission:', permission);
//         setNotificationPermission(permission);

//         // Determine if we should show the modal and/or make API call
//         // Show modal in these cases:
//         // 1. Browser permission is 'default' (need browser permission first)
//         // 2. User is not subscribed (need user consent even if browser permission exists)
//         const shouldShowModal = permission === 'default' || !currentIsSubscribed;
        
//         // Only make direct API call if:
//         // - User is not subscribed AND permission is granted AND we've already shown modal once
//         // This prevents auto-API calls on component mount
//         const shouldMakeApiCall = false; // We'll only call API through user interaction

//         console.log('[Debug] shouldShowModal:', shouldShowModal, 'shouldMakeApiCall:', shouldMakeApiCall);
//         console.log('[Debug] permission:', permission, 'currentIsSubscribed:', currentIsSubscribed);

//         if (shouldShowModal) {
//             if (permission === 'default') {
//                 console.log('[Prompt] Showing permission prompt to user (browser permission needed)');
//             } else {
//                 console.log('[Prompt] Showing permission prompt to user (user consent needed)');
//             }
//             setShowPrompt(true);
//         } else if (currentIsSubscribed && permission === 'granted') {
//             console.log('[Info] User already subscribed and permission granted, no action needed');
//         } else if (permission === 'denied') {
//             console.log('[Info] Notifications denied by user, no action needed');
//         }
//     }, [userId, currentIsSubscribed]);

//     // Separate effect to handle page reload scenarios
//     useEffect(() => {
//         console.log('[Page Reload Handler] Checking for page reload scenario');
        
//         // On every mount, ensure we have the latest isSubscribed value from localStorage
//         const storedIsSubscribed = getIsSubscribed();
//         if (storedIsSubscribed !== currentIsSubscribed) {
//             console.log('[Page Reload] Updating isSubscribed from localStorage:', storedIsSubscribed);
//             setCurrentIsSubscribed(storedIsSubscribed);
//         }
//     }, []); // Empty dependency array - runs once on mount (page reload)

//     const handlePushSubscription = async () => {
//         setSnackbar({ open: true, message: 'Subscribing to notifications...', severity: 'info' });
        
//         try {
//             // Check for VAPID key before proceeding
//             const vapidKey = process.env.REACT_APP_VAPID_PUBLIC_KEY;
//             if (!vapidKey) {
//                 throw new Error('VAPID public key is missing from environment variables.');
//             }
//             console.log('[Debug] VAPID Key found. Proceeding...');

//             // Get service worker registration
//             const registration = await navigator.serviceWorker.ready;
//             console.log('[Debug] Service Worker is ready.');

//             // Get existing subscription
//             let subscription = await registration.pushManager.getSubscription();
            
//             // Unsubscribe if VAPID key has changed
//             if (subscription) {
//                 const currentKey = subscription.options.applicationServerKey;
//                 const newKey = urlBase64ToUint8Array(vapidKey);
                
//                 if (!currentKey || !arrayBufferEqual(currentKey, newKey)) {
//                     console.log('[Info] VAPID key has changed. Unsubscribing old subscription...');
//                     await subscription.unsubscribe();
//                     subscription = null;
//                 }
//             }

//             // Create a new subscription if one does not exist
//             if (!subscription) {
//                 console.log('[Debug] No existing subscription found. Creating a new one...');
//                 subscription = await registration.pushManager.subscribe({
//                     userVisibleOnly: true,
//                     applicationServerKey: urlBase64ToUint8Array(vapidKey),
//                 });
//                 console.log('[Success] New subscription created:', subscription.endpoint);
//             } else {
//                 console.log('[Success] Reusing existing subscription:', subscription.endpoint);
//             }

//             // Prepare payload for API call
//             const payload = {
//                 user_id: userId,
//                 subscription: {
//                     endpoint: subscription.endpoint,
//                     keys: {
//                         auth: subscription.toJSON().keys.auth,
//                         p256dh: subscription.toJSON().keys.p256dh,
//                     },
//                 },
//             };

//             const accessToken = localStorage.getItem('accessToken');
//             console.log('[Debug] accessToken from localStorage:', accessToken ? 'Exists' : 'Does not exist');

//             if (!accessToken) {
//                 throw new Error('User is not authenticated. Cannot save push subscription.');
//             }

//             // Log the axios config before the call
//             const axiosConfig = localAxiosToken('/notifications/savePushSubscription', payload, accessToken);
//             console.log('[Debug] Axios config for API call:', JSON.stringify(axiosConfig, null, 2));

//             // Make the API call
//             const response = await axios(axiosConfig);
            
//             console.log('[Success] API call to save subscription succeeded:', response.data);
            
//             // Update local state and localStorage to reflect successful subscription
//             setCurrentIsSubscribed(true);
//             localStorage.setItem('isSubscribed', 'true');
            
//             // Show appropriate success message
//             const successMessage = currentIsSubscribed 
//                 ? 'Browser subscription updated successfully!' 
//                 : 'Successfully subscribed to notifications!';
            
//             setSnackbar({
//                 open: true,
//                 message: successMessage,
//                 severity: 'success',
//             });
//             setShowPrompt(false);
//         } catch (error) {
//             console.error('[Error] Subscription process failed:', error);
//             setSnackbar({
//                 open: true,
//                 message: `Failed to subscribe: ${error.message || 'Unknown error'}`,
//                 severity: 'error',
//             });
//         }
//     };

//     const requestNotificationPermission = async () => {
//         try {
//             let permission = notificationPermission;
            
//             // Only request permission if it's 'default'
//             if (permission === 'default') {
//                 permission = await Notification.requestPermission();
//                 setNotificationPermission(permission);
//             }
            
//             if (permission === 'granted') {
//                 console.log('[Info] Notification permission available.');
                
//                 // Always make API call when user grants permission
//                 // This handles both new users and existing users on new browsers
//                 if (permission === 'granted') {
//                     console.log('[Info] Making subscription API call...');
//                     await handlePushSubscription();
//                 }
//                 setShowPrompt(false);
//             } else if (permission === 'denied') {
//                 console.warn('[Warning] Notification permission denied by user.');
//                 setSnackbar({
//                     open: true,
//                     message: 'Permission denied. You can enable it in your browser settings.',
//                     severity: 'warning',
//                 });
//                 setShowPrompt(false);
//             }
//         } catch (error) {
//             console.error('[Error] Error requesting permission:', error);
//             setSnackbar({ open: true, message: `Failed to request permission: ${error.message}`, severity: 'error' });
//         }
//     };

//     const handleClose = () => setShowPrompt(false);
//     const handleSnackbarClose = () => setSnackbar(prev => ({ ...prev, open: false }));

//     // Show modal in these cases:
//     // 1. Browser permission is 'default' (need browser permission)
//     // 2. User is not subscribed (need user consent)
//     const shouldShowModal = (notificationPermission === 'default' || !currentIsSubscribed) && showPrompt;

//     return (
//         <>
//             <Modal
//                 open={shouldShowModal}
//                 onClose={handleClose}
//                 aria-labelledby="notification-permission-modal"
//                 aria-describedby="notification-permission-description"
//             >
//                 <Box
//                     sx={{
//                         position: 'absolute',
//                         top: '50%',
//                         left: '50%',
//                         transform: 'translate(-50%, -50%)',
//                         width: { xs: '90%', sm: '80%', md: '500px' },
//                         bgcolor: 'background.paper',
//                         boxShadow: 24,
//                         p: 4,
//                         borderRadius: 2,
//                         outline: 'none'
//                     }}
//                 >
//                     <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//                         <Typography variant="h6" component="h1" fontWeight='600'>
//                             Enable Notifications
//                         </Typography>
//                         <IconButton onClick={handleClose}>
//                             <CloseIcon />
//                         </IconButton>
//                     </Box>
                    
//                     <Typography variant="body1" sx={{ mb: 3 }}>
//                         {notificationPermission === 'default' 
//                             ? "Would you like to receive notifications from our application? This will allow us to keep you updated with important information."
//                             : "Enable push notifications to stay updated with important information and updates from our application."
//                         }
//                     </Typography>
                    
//                     <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
//                         <Button 
//                             variant="outlined" 
//                             onClick={handleClose}
//                         >
//                             Not Now
//                         </Button>
//                         <Button 
//                             variant="contained" 
//                             onClick={requestNotificationPermission}
//                         >
//                             Allow
//                         </Button>
//                     </Box>
//                 </Box>
//             </Modal>

//             <Snackbar
//                 open={snackbar.open}
//                 autoHideDuration={6000}
//                 onClose={handleSnackbarClose}
//                 anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
//             >
//                 <Alert 
//                     onClose={handleSnackbarClose} 
//                     severity={snackbar.severity}
//                     sx={{ width: '100%' }}
//                 >
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//         </>
//     );
// };

// export default PushNotificationManager;

import React, { useState, useEffect, useRef } from 'react';
import { 
    Modal,
    Box,
    Typography,
    Button,
    IconButton,
    Snackbar,
    Alert
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';

import { axiosInstance, localAxiosToken} from '../Axios/axios'

// Helper function to convert VAPID key
const urlBase64ToUint8Array = (base64String) => {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/');
    const rawData = window.atob(base64);
    return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
};

// Helper function to compare array buffers
const arrayBufferEqual = (buf1, buf2) => {
    if (buf1.byteLength !== buf2.byteLength) return false;
    const dv1 = new Uint8Array(buf1);
    const dv2 = new Uint8Array(buf2);
    for (let i = 0; i < buf1.byteLength; i++) {
        if (dv1[i] !== dv2[i]) return false;
    }
    return true;
};

const PushNotificationManager = ({ userId, isSubscribed: propIsSubscribed }) => {
    const [showPrompt, setShowPrompt] = useState(false);
    const [notificationPermission, setNotificationPermission] = useState('default');
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });
    const initialized = useRef(false);
    
    // Get isSubscribed from props or localStorage
    const getIsSubscribed = () => {
        if (propIsSubscribed !== undefined) {
            return propIsSubscribed;
        }
        const storedValue = localStorage.getItem('isSubscribed');
        return storedValue === 'true'; // Convert string to boolean
    };
    
    const [currentIsSubscribed, setCurrentIsSubscribed] = useState(getIsSubscribed());

    // console.log('[Debug] Component props - userId:', userId, 'propIsSubscribed:', propIsSubscribed);
    // console.log('[Debug] Final isSubscribed value:', currentIsSubscribed);

    useEffect(() => {
        // console.log('[Component] PushNotificationManager mounted/updated (Page reload scenario included)');
        // console.log('[Debug] userId:', userId, 'currentIsSubscribed:', currentIsSubscribed);
        
        if (!userId) {
            console.log('[Debug] No userId provided, skipping initialization');
            return;
        }

        // Always check for latest isSubscribed value from localStorage (handles page reload)
        const latestIsSubscribed = getIsSubscribed();
        if (currentIsSubscribed !== latestIsSubscribed) {
            // console.log('[Debug] isSubscribed value changed, reinitializing...');
            initialized.current = false;
            setCurrentIsSubscribed(latestIsSubscribed);
            return; // Return early, let the next effect run handle the new value
        }

        if (initialized.current) {
            // console.log('[Debug] Component already initialized for current state, skipping');
            return;
        }

        // console.log('[Debug] Initializing component (fresh mount or page reload)');
        initialized.current = true;

        if (!('Notification' in window) || !('serviceWorker' in navigator) || !('PushManager' in window)) {
            console.error('[Error] Push notifications are not supported in this browser.');
            return;
        }

        // Check current permission state
        const permission = Notification.permission;
        // console.log('[Debug] Current notification permission:', permission);
        setNotificationPermission(permission);

        // Determine if we should show the modal and/or make API call
        // Show modal in these cases:
        // 1. Browser permission is 'default' (need browser permission first)
        // 2. User is not subscribed (need user consent even if browser permission exists)
        const shouldShowModal = permission === 'default' || !currentIsSubscribed;
        
        // Only make direct API call if:
        // - User is not subscribed AND permission is granted AND we've already shown modal once
        // This prevents auto-API calls on component mount
        const shouldMakeApiCall = false; // We'll only call API through user interaction

        // console.log('[Debug] shouldShowModal:', shouldShowModal, 'shouldMakeApiCall:', shouldMakeApiCall);
        // console.log('[Debug] permission:', permission, 'currentIsSubscribed:', currentIsSubscribed);

        if (shouldShowModal) {
            if (permission === 'default') {
                console.log('[Prompt] Showing permission prompt to user (browser permission needed)');
            } else {
                console.log('[Prompt] Showing permission prompt to user (user consent needed)');
            }
            setShowPrompt(true);
        } else if (currentIsSubscribed && permission === 'granted') {
            console.log('[Info] User already subscribed and permission granted, no action needed');
        } else if (permission === 'denied') {
            console.log('[Info] Notifications denied by user, no action needed');
        }
    }, [userId, currentIsSubscribed]);

    // Separate effect to handle page reload scenarios
    useEffect(() => {
        // console.log('[Page Reload Handler] Checking for page reload scenario');
        
        // On every mount, ensure we have the latest isSubscribed value from localStorage
        const storedIsSubscribed = getIsSubscribed();
        if (storedIsSubscribed !== currentIsSubscribed) {
            // console.log('[Page Reload] Updating isSubscribed from localStorage:', storedIsSubscribed);
            setCurrentIsSubscribed(storedIsSubscribed);
        }
    }, []); // Empty dependency array - runs once on mount (page reload)

    const handlePushSubscription = async () => {
        setSnackbar({ open: true, message: 'Subscribing to notifications...', severity: 'info' });
        
        try {
            // Check for VAPID key before proceeding
            const vapidKey = process.env.REACT_APP_VAPID_PUBLIC_KEY;
            if (!vapidKey) {
                throw new Error('VAPID public key is missing from environment variables.');
            }
            // console.log('[Debug] VAPID Key found. Proceeding...');

            // Get service worker registration
            const registration = await navigator.serviceWorker.ready;
            // console.log('[Debug] Service Worker is ready.');

            // Get existing subscription
            let subscription = await registration.pushManager.getSubscription();
            
            // Unsubscribe if VAPID key has changed
            if (subscription) {
                const currentKey = subscription.options.applicationServerKey;
                const newKey = urlBase64ToUint8Array(vapidKey);
                
                if (!currentKey || !arrayBufferEqual(currentKey, newKey)) {
                    // console.log('[Info] VAPID key has changed. Unsubscribing old subscription...');
                    await subscription.unsubscribe();
                    subscription = null;
                }
            }

            // Create a new subscription if one does not exist
            if (!subscription) {
                // console.log('[Debug] No existing subscription found. Creating a new one...');
                subscription = await registration.pushManager.subscribe({
                    userVisibleOnly: true,
                    applicationServerKey: urlBase64ToUint8Array(vapidKey),
                });
                // console.log('[Success] New subscription created:', subscription.endpoint);
            } else {
                // console.log('[Success] Reusing existing subscription:', subscription.endpoint);
            }

            // Prepare payload for API call
            const payload = {
                user_id: userId,
                subscription: {
                    endpoint: subscription.endpoint,
                    keys: {
                        auth: subscription.toJSON().keys.auth,
                        p256dh: subscription.toJSON().keys.p256dh,
                    },
                },
            };

            const accessToken = localStorage.getItem('accessToken');
            // console.log('[Debug] accessToken from localStorage:', accessToken ? 'Exists' : 'Does not exist');

            if (!accessToken) {
                throw new Error('User is not authenticated. Cannot save push subscription.');
            }

            // Log the axios config before the call
            const axiosConfig = localAxiosToken('/notifications/savePushSubscription', payload);
            // console.log('[Debug] Axios config for API call:', JSON.stringify(axiosConfig, null, 2));

            // Make the API call
            const response = await axiosInstance(axiosConfig);
            
            // console.log('[Success] API call to save subscription succeeded:', response.data);
            
            // Update local state and localStorage to reflect successful subscription
            setCurrentIsSubscribed(true);
            localStorage.setItem('isSubscribed', 'true');
            
            // Show appropriate success message
            const successMessage = currentIsSubscribed 
                ? 'Browser subscription updated successfully!' 
                : 'Successfully subscribed to notifications!';
            
            setSnackbar({
                open: true,
                message: successMessage,
                severity: 'success',
            });
            setShowPrompt(false);
        } catch (error) {
            console.error('[Error] Subscription process failed:', error);
            setSnackbar({
                open: true,
                message: `Failed to subscribe: ${error.message || 'Unknown error'}`,
                severity: 'error',
            });
        }
    };

    const requestNotificationPermission = async () => {
        try {
            let permission = notificationPermission;
            
            // Only request permission if it's 'default'
            if (permission === 'default') {
                permission = await Notification.requestPermission();
                setNotificationPermission(permission);
            }
            
            if (permission === 'granted') {
                console.log('[Info] Notification permission available.');
                
                // Always make API call when user grants permission
                // This handles both new users and existing users on new browsers
                if (permission === 'granted') {
                    console.log('[Info] Making subscription API call...');
                    await handlePushSubscription();
                }
                setShowPrompt(false);
            } else if (permission === 'denied') {
                console.warn('[Warning] Notification permission denied by user.');
                setSnackbar({
                    open: true,
                    message: 'Permission denied. You can enable it in your browser settings.',
                    severity: 'warning',
                });
                setShowPrompt(false);
            }
        } catch (error) {
            console.error('[Error] Error requesting permission:', error);
            setSnackbar({ open: true, message: `Failed to request permission: ${error.message}`, severity: 'error' });
        }
    };

    const handleClose = () => setShowPrompt(false);
    const handleSnackbarClose = () => setSnackbar(prev => ({ ...prev, open: false }));

    // Show modal in these cases:
    // 1. Browser permission is 'default' (need browser permission)
    // 2. User is not subscribed (need user consent)
    const shouldShowModal = (notificationPermission === 'default' || !currentIsSubscribed) && showPrompt;

    return (
        <>
            <Modal
                open={shouldShowModal}
                onClose={handleClose}
                aria-labelledby="notification-permission-modal"
                aria-describedby="notification-permission-description"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: { xs: '90%', sm: '80%', md: '500px' },
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 4,
                        borderRadius: 2,
                        outline: 'none'
                    }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6" component="h1" fontWeight='600'>
                            Enable Notifications
                        </Typography>
                        <IconButton onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    
                    <Typography variant="body1" sx={{ mb: 3 }}>
                        {notificationPermission === 'default' 
                            ? "Would you like to receive notifications from our application? This will allow us to keep you updated with important information."
                            : "Enable push notifications to stay updated with important information and updates from our application."
                        }
                    </Typography>
                    
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                        <Button 
                            variant="outlined" 
                            onClick={handleClose}
                        >
                            Not Now
                        </Button>
                        <Button 
                            variant="contained" 
                            onClick={requestNotificationPermission}
                        >
                            Allow
                        </Button>
                    </Box>
                </Box>
            </Modal>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <Alert 
                    onClose={handleSnackbarClose} 
                    severity={snackbar.severity}
                    sx={{ width: '100%' }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </>
    );
};

export default PushNotificationManager;
